import { styled } from '@linaria/react';
import Image from 'next/image';

export const Container = styled.div<{
	bottomOffset?: string | number;
}>`
	--bottom-offset: ${({ bottomOffset = 120 }) =>
		typeof bottomOffset === 'string' ? `${bottomOffset}` : `${bottomOffset}px`};

	position: fixed;
	display: flex;
	right: 0;
	width: 200px;
	height: 200px;
	z-index: 2;
	pointer-events: none;
	align-items: center;
	justify-content: center;

	@media screen and (max-width: 380px) {
		right: -20px;
		bottom: var(--bottom-offset);
	}

	@media screen and (min-width: 380px) and (max-width: 600px) {
		right: -20px;
		bottom: var(--bottom-offset);
	}
	@media screen and (min-width: 600px) {
		top: 100px;
	}

	&:hover {
		filter: drop-shadow(2px 2px 8px var(--color-white-03));
	}
`;

export const ClickableArea = styled.button`
	pointer-events: auto;
	width: 120px;
	height: 120px;
`;

export const PromoEventImage = styled(Image)`
	position: absolute;
`;
